// bao migrate skip
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import * as $ from "jquery";
import BaoDialogViewModel from "./../factories/bao-dialog";


function SelectClientViewModel(mvcModel) {
    var self = this;
    self.Active = ko.observable(true);
    ko.map.fromJS(mvcModel, self);
    var ignoreSelect = false;
    self.ClientId = ko.observable();
    self.SelectId = function (selectedClient) {
        self.ClientId(selectedClient.Id());
        if (ignoreSelect == false) {
            self.SelectClient();
        }
        else {
            ignoreSelect = false;
        }
    };
    self.Redirect = "";
    self.LoginModel = null;
    self.Dialog = new BaoDialogViewModel(Bao.Session.ApplicationName);
    self.UseHash = true;
    self.SelectClient = function () {
        if (self.ClientId() != null) {
            self.Dialog.IsLoading(true);
            Bao.post("Login/SelectClient", JSON.stringify({
                clientId: self.ClientId()
            }), function (value) {
                if (value.Result == true) {
                    var url;
                    if (self.UseHash) {
                        url = self.Redirect + window.location.hash;
                    }
                    else {
                        url = self.Redirect;
                    }
                    window.location = url;
                }
                else {
                    self.Dialog.IsLoading(false);
                    if (self.LoginModel != null) {
                        self.LoginModel.IsLoading(false);
                    }
                    self.Dialog.Template(value.Message);
                    self.Dialog.Open();
                }
            }).fail(function (value) {
                self.Dialog.Template(value);
                self.Dialog.Open();
            });
        }
    };
    self.SelectedIndex = ko.observable(0);
    self.SelectedIndex.subscribe(function (value) {
        self.SelectId(self.ClientCollection()[value]);
    });
    $(document).keydown(function (e) {
        if (e.keyCode == 38) {
            if (self.SelectedIndex() > 0) {
                ignoreSelect = true;
                self.SelectedIndex(self.SelectedIndex() - 1);
            }
        }
        else if (e.keyCode == 40) {
            if (self.ClientCollection != null && self.ClientCollection().length > 0 && self.SelectedIndex() < self.ClientCollection().length - 1) {
                ignoreSelect = true;
                self.SelectedIndex(self.SelectedIndex() + 1);
            }
        }
        else if (e.keyCode == 13) {
            if (self.Active()) {
                self.SelectClient();
            }
        }
    });
    return self;
}
export default SelectClientViewModel;